import Enum from "./Enum";

export default Enum.create( {
	OUTCOME_IMPORTANCE: "OUTCOME_IMPORTANCE",
	COMPLETED_RECENTLY: "COMPLETED_RECENTLY",
	CREATED_RECENTLY: "CREATED_RECENTLY",
} );
